import { Permissions } from "@cnx/common";

export const isHasRequiredRights = (
  userRights: Permissions[],
  rights: Permissions[]
) => userRights.some(right => rights.includes(right));
